var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLaunchInfo = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 22,
  viewBox: "0 0 21 22",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 11,
  r: 10.192
}), /*#__PURE__*/React.createElement("path", {
  fill: "#348cfd",
  d: "M10.5.81C4.87.81.308 5.372.308 11.001c0 5.629 4.563 10.192 10.192 10.192 5.63 0 10.192-4.563 10.192-10.192C20.692 5.372 16.13.809 10.5.809zm0 1a9.192 9.192 0 1 1-9.192 9.192A9.192 9.192 0 0 1 10.5 1.809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#348cfd",
  d: "M9.692 8.885c.677 0 1.234.514 1.301 1.174l.007.133v5.654a.5.5 0 0 1-.992.09l-.008-.09v-5.654a.31.31 0 0 0-.237-.3l-.07-.007H8.076a.5.5 0 0 1-.09-.992l.09-.008h1.615zm-.404-4.039.114.007a.904.904 0 1 1-.227 0l.113-.007z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#348cfd",
  d: "M12.923 15.348a.5.5 0 0 1 .09.992l-.09.008H8.077a.5.5 0 0 1-.09-.992l.09-.008h4.846z"
}))));
export { SvgLaunchInfo as ReactComponent };
export default __webpack_public_path__ + "assets/images/launch-info.svg";